export default {
  common: {
    casino: "Sòng bạc",
    more: "Thêm",
    searchGames: "Tìm trò chơi",
    copied: "Đã sao chép!",
    inputTooLong: "Nội dung nhập quá dài, vui lòng nhập lại.",
    inputNameCn: "Chỉ cho phép ký tự tiếng Trung, chữ cái, số và dấu gạch dưới",
    inputCapital: "Chỉ cho phép chữ in hoa và dấu gạch dưới",
    inputLowercaseUnderscore: "Chỉ cho phép chữ thường và dấu gạch dưới",
    inputLowercase: "Chỉ cho phép chữ thường",
    inputNoSpace: "Vui lòng không nhập chỉ khoảng trắng",
    inputValidPhone: "Vui lòng nhập số điện thoại hợp lệ",
    inputNonNumber: "Chứa ký tự không phải số",
    inputNonLetter: "Chứa ký tự không phải chữ cái",
    inputLetterOrNumberOnly: "Chỉ cho phép chữ cái hoặc số",
    phoneFormatError: "Định dạng số điện thoại không hợp lệ",
    inputLetterStartNumber: "Phải bắt đầu bằng chữ cái và có thể chứa số",
    inputNoChinese: "Không cho phép ký tự tiếng Trung",
    inputChineseOnly: "Chỉ cho phép ký tự tiếng Trung",
    emailFormatError: "Định dạng email không hợp lệ",
    urlFormatError: "Định dạng URL không hợp lệ",
    jsonFormatError: "Định dạng JSON không hợp lệ",
    networkError: "Không thể kết nối đến máy chủ, vui lòng thử lại sau.",
    siteUnavailable: "Trang web này hiện không khả dụng, vui lòng liên hệ quản trị viên.",
    tokenExpired: "Phiên của bạn đã hết hạn, vui lòng đăng nhập lại.",
    domainNotAuthorized: "Tên miền chưa được ủy quyền",
    demoEnvOnly: "Môi trường demo, chỉ để xem trước",
    passwordLength630: "6-30 ký tự",
    newPasswordSameAsOld: "Mật khẩu mới không được trùng với mật khẩu cũ",
    confirmNewPassword: "Vui lòng xác nhận mật khẩu mới của bạn",
    passwordsDoNotMatch: "Mật khẩu không khớp",
    withdrawPasswordChanged: "Đổi mật khẩu rút tiền thành công",
    withdrawPasswordSet: "Thiết lập mật khẩu rút tiền thành công",
    withdrawPasswordSetFailed: "Thiết lập mật khẩu rút tiền thất bại",
    phoneDigitsOnly: "Số điện thoại chỉ được chứa chữ số",
    phoneTooShort: "Số điện thoại quá ngắn (tối thiểu {min} chữ số)",
    phoneTooLong: "Số điện thoại quá dài (tối đa {max} chữ số)",
    phoneInvalidPrefix: "Tiền tố số điện thoại không hợp lệ",
    rolloverAll: "Tất cả loại",
    rolloverAllStats: "Tất cả trạng thái",
    rolloverSuccessful: "Thành công",
    rolloverFailed: "Thất bại",
    rolloverInProgress: "Đang xử lý",
    rolloverSuccess: "Thành công",
    rolloverPending: "Đang chờ",
    rolloverCompleted: "Hoàn thành",
    rolloverCancelled: "Đã hủy",
    rolloverExpired: "Đã hết hạn",
    walletCash: "Tiền mặt",
    walletBonus: "Tiền thưởng",
    sourceDeposit: "Nạp",
    sourceCommission: "Hoa hồng",
    sourceManualAdd: "Thêm thủ công",
    sourceManualSubtract: "Trừ thủ công",
  },
  redeemCode: {
    enterTip: "Nhập mã đổi thưởng của bạn để nhận phần thưởng",
    placeholder: "Vui lòng nhập mã của bạn",
    redeemBtn: "ĐỔI THƯỞNG",
    pleaseEnterCode: "Vui lòng nhập mã đổi thưởng của bạn",
    redeemSuccess: "Đổi thưởng thành công!",
    redeemFailed: "Đổi thưởng thất bại, vui lòng thử lại",
  },
}
